export enum EHomeownerTrap {
  myHome = 'myHome',
  cpd = 'cpd',
}
